import { createFileRoute, Outlet } from "@tanstack/solid-router";

export const Route = createFileRoute("/_dashboard/dashboard/fixed-assets")({
  staticData: {
    breadcrumb: "Fixed Assets",
  },
  component: () => <Outlet />,
});
